(() => {
  if (window.orrlingRingSizeInstalled) return;
  window.orrlingRingSizeInstalled = true;
  const dataNode = document.getElementById('orrling-ring-size-data');
  if (!dataNode) return;
  const data = JSON.parse(dataNode.textContent);
  const variants = data.variants || [];
  const sizeIndex = (data.options || []).findIndex(name => /^(ring\s*size|ringstorlek|storlek|size)$/i.test(name.trim()));
  const validSize = value => /^\d{2}(?:[.,]0{1,2})?$/.test(String(value)) && Number(String(value).replace(',', '.')) >= 45 && Number(String(value).replace(',', '.')) <= 64;
  const key = id => `orrling-ring-size:${id}`;
  const read = id => { try { return JSON.parse(sessionStorage.getItem(key(id))); } catch { return null; } };
  const write = value => { try { sessionStorage.setItem(key(value.variantId), JSON.stringify(value)); } catch {} };
  const isDiamondLink = link => {
    try {
      const url = new URL(link.href, location.origin);
      return url.origin === location.origin && url.pathname.toLowerCase().endsWith('/pages/design-your-ring') && url.searchParams.get('stage') === 'Add Diamond';
    } catch { return false; }
  };
  const selectedVariant = link => {
    const scope = link.closest('.shopify-section') || document;
    const picker = scope.querySelector('variant-picker');
    if (picker) {
      const selects = [...picker.querySelectorAll('select[name^="options["]')];
      if (selects.length === data.options.length) {
        return variants.find(v => v.options.every((value, index) => value === selects[index].value));
      }
    }
    const id = scope.querySelector('form[action*="/cart/add"] [name="id"]')?.value || new URL(link.href).searchParams.get('settingVariantId') || data.selectedId;
    return variants.find(v => String(v.id) === String(id));
  };
  const syncLink = link => {
    if (sizeIndex < 0 || !isDiamondLink(link)) return true;
    const variant = selectedVariant(link);
    if (!variant || !validSize(variant.options[sizeIndex])) return false;
    const size = Number(variant.options[sizeIndex].replace(',', '.')).toFixed(2);
    const url = new URL(link.href, location.origin);
    url.searchParams.set('settingId', String(data.productId));
    url.searchParams.set('settingVariantId', String(variant.id));
    url.searchParams.set('ringRegion', 'EUROPE');
    url.searchParams.set('ringSize', size);
    if (link.href !== url.href) link.href = url.href;
    write({productId: String(data.productId), variantId: String(variant.id), size, productUrl: data.productUrl, title: variant.title});
    return true;
  };
  const syncSummary = () => {
    const params = new URLSearchParams(location.search);
    const record = read(params.get('settingVariantId'));
    const matches = record && record.productId === params.get('settingId') && validSize(record.size) && record.size === params.get('ringSize') && params.get('ringRegion') === 'EUROPE' && params.get('stage') === 'Complete Ring';
    document.querySelectorAll('button[role="combobox"].diamond-proxy-dropdown-trigger').forEach(button => {
      const confirmed = matches && button.textContent.trim() === record.size;
      let summary = button.parentElement.querySelector('.orrling-ring-size-summary');
      if (!confirmed) {
        button.classList.remove('orrling-ring-size-confirmed');
        summary?.remove();
        return;
      }
      if (!summary) {
        summary = document.createElement('p');
        summary.className = 'orrling-ring-size-summary';
        const value = document.createElement('span');
        value.textContent = `${Number(record.size)} · ${data.label}`;
        const change = document.createElement('a');
        const target = new URL(record.productUrl, location.origin);
        if (target.origin !== location.origin) return;
        target.searchParams.set('variant', record.variantId);
        change.href = target.href;
        change.textContent = data.change;
        summary.append(value, change);
        button.parentElement.append(summary);
      }
      button.classList.add('orrling-ring-size-confirmed');
    });
  };
  let pending = false;
  const sync = () => {
    pending = false;
    if (data.productId) document.querySelectorAll('a[href]').forEach(link => { if (isDiamondLink(link)) syncLink(link); });
    else syncSummary();
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(sync); } };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!data.productId || !link || !isDiamondLink(link)) return;
    if (!syncLink(link)) {
      event.preventDefault();
      alert(data.required);
    }
  });
  document.addEventListener('change', schedule);
  document.addEventListener('variant:update', schedule);
  window.addEventListener('popstate', schedule);
  window.addEventListener('pageshow', schedule);
  new MutationObserver(schedule).observe(document.getElementById('MainContent') || document.body, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href']});
  sync();
})();
